import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _FixedAssetLine } from "../../../../../core/services/dataBean/EntityCatalog";

interface Props {
    label?: string;
    idSelector: number;
    onChange: Function;
    idLine: number;
}

export const SelectorBrandDestinityAccountantID = ({ idSelector, onChange, label, idLine }: Props) => {

    const { lista, setLista, instance } = useDataBean(_FixedAssetLine)
    const [id, setID] = useState<any>("");

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idLine])

    const setValue = (e: string) => {
        const selectedId = e;
        setID(selectedId);
        if (onChange) {
            // const selectedItem = lista.find(item => item.DataBeanProperties.IDBusinessCore == e);
            onChange(selectedId);
        }
    };

    const getLista = () => {
        instance.getBrandListForFixedAssetLine(idLine).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp);
                    setID("");
                    onChange?.("")
                }
            }
        ).catch(err => { toast.error(err) })
    }

    return (
        <>
            <label>{label ?? "Core de Negocio"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>

                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Value} - {item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}